<template>
  <div class="search" ref="searchContain" 
    :class="{'empty': !search, 'focused': focused}" id="searchContain">
    <input
      placeholder=""
      v-model="search"
      @input="input"
      class="search-input"
      aria-describedby="addon-right addon-left"
    />
    <div class="search-wrapper" @click.prevent.stop="focused = !focused">
      <svg class="svg-angle svg-angle-right" width="25" height="25" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <svg class="svg-angle svg-angle-left" width="25" height="25" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <div class="search-cover">
        <div class="search-icon">
          <i class="ti ti-search"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Search",
  data() {
    return {
      focused: false,
      search: "",
    };
  },
  methods: {
    input() {
      this.$emit("input", this.search);
    },
  },
};
</script>
<style>
</style>
